import React from 'react';
import PropTypes from 'prop-types';
import { Scroll } from './../Icons';
import classnames from 'classnames';

const ScrollButton = (props) => {
  const { className = '', isHorizontal = false, theme, title = 'Next Section', ...rest } = props;
  const Tag = props?.href ? 'a' : 'button';
  const themeClass = theme ? `scroll-button--${theme}` : '';

  return (
    <Tag
      className={classnames(
        'scroll-button',
        { 'scroll-button--horizontal': isHorizontal },
        { [className]: className },
        { [themeClass]: themeClass },
      )}
      {...rest}
    >
      <Scroll className={'scroll-button__icon'} />
      <span className={'scroll-button__title'}>{title}</span>
    </Tag>
  );
};

ScrollButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  isHorizontal: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
};

export default ScrollButton;
